module.exports = __webpack_public_path__ + "img/icon-track-blue.b352e96d.svg";